// DATA
// button > id / isLast 필수

/**
 * action (next | finish | route | hintView)
 * next: 다음 채팅으로 이동 (onFinish 미사용)
 * finish: 게임 종료 (onFinish 필요)
 * route: 페이지 이동 (onFinish 필요, useNavigate)
 */

/*
{
  type: "button",
  classes: ["inputBtn02", "mt20"],
  id: "btn1",
  label: "시작하기",
  isLast: true,
},
*/
export const CHAT_DATA = {
  dataArr01: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "방탈출 안내사항을 확인해 주세요.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "agentM",
      chat_tit: "에이전트 M",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">1. 외부 유출 금지!</span><br/>협력 추리 게임, 모들의 문제는 저작권법에 의해 보호받고 있습니다. 마인드 미스터리 문제는 모두의 재미를 위해 외부 유출을 금지합니다.',
    },

    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">2. 문의사항은 담당자</span><br/>협력 추리 게임, 모들과 관련된 문의는 담당자에게 문의해주세요.',
    },

    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">3. 제한시간</span><br/>이 추리 게임은 제한시간동안 즐길 수 있습니다. 중요한 단서는 메모하세요!',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">4. 일부 키워드는 비밀번호가 필요합니다.</span><br/>특정 키워드는 🔒 표시와 함께 잠겨있습니다. 다른 키워드에서 비밀번호를 찾아 입력하세요!',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "네 알겠습니다",
      isLast: true,
      action: "route", // next | finish | route
      route: "/tutorial",
    },
  ],
  dataArr02: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "방탈출 스토리를 확인해주세요.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "agentM",
      chat_tit: "에이전트 M",
      talkType: "chat_b_left_Talk",
      text: '당신은 추리수사본부 <span class="txtW700">AIM</span>에서 첫 임무를 맡은 인턴 요원입니다.',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "오늘은 저, 선임요원 '에이전트 M'과 함께 특별한 임무를 수행합니다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "바로, 미스터리 사건이 벌어진 한 사무실에서 사건의 진상을 조사하는 것입니다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "과연, 무사히 미션을 완료할 수 있을까요?",
    },

    {
      type: "left_txt",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">첫 추리 키워드</span>를 입력하세요.',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "추리 키워드 입력하기",
      isLast: true,
      action: "route", // next | finish | route
      route: "/keywordInput", // action === "route" 일 때
    },
  ],
  //st1
  infoData1: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "1. 사건개요",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "agentM",
      chat_tit: "에이전트 M",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">메인 사건: 보고서 오류</span><br/>3월 15일, 마케팅팀 분기 보고서<br/><span class="txtW700">"-20% 하락"</span> → 기입 오류<br/>"+20% 상승" → 정상 데이터<br/>박진호(데이터 담당) 정직 조치 진행<br/><br/><span class="txtW700">그런데 조사 중 발견된 다른 의혹들:</span>',
    },

    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">사건 A: 기밀 유출 의혹</span><br/>김하린(PR) 외부 기자와 수상한 접촉',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">사건 B: 공금 유용 의혹</span><br/>이서연(기획) 법인카드 부정 사용',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">사건 C: 압박 의혹</span><br/>정우석(팀장) 본사로부터 과도한 압박?',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">사건 D: 의도적 방치 의혹</span><br/>누군가 문제를 알고도 침묵',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">⚠️ 특수 규칙: 잠긴 정보</span><br/>일부 키워드는 🔒 표시와 함께 비밀번호가 필요합니다. 다른 키워드에서 비밀번호를 찾아 입력하세요.',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "참가자 역할 확인",
      isLast: true,
      action: "route", // next | finish | route
      route: "/info", // action === "route" 일 때
      state: {
        DateVal: "infoData2",
        titImgClass: "messageTit01",
      },
    },
  ],
  infoData2: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "2. 참가자 역할",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "agentM",
      chat_tit: "에이전트 M",
      talkType: "chat_b_left_Talk",
      text: '참가자는 추리수사본부 <span class="txtW700">AIM</span>의 인턴 요원이 되어, “침묵의 방”에서 벌어진 사건을 조사합니다.',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '이 게임의 플레이어들은 라운드 동안  팀처럼 단서를 공유·토론하고  <span class="txtW700">최종 정답은 각자 제출</span>합니다.',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "모두가 한 팀이 되어 함께 추리하지만, 각자가 생각하는 결과는 다를 수 있습니다.",
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "게임 방법 확인",
      isLast: true,
      action: "route", // next | finish | route
      route: "/info", // action === "route" 일 때
      state: {
        DateVal: "infoData3",
        titImgClass: "messageTit01",
      },
    },
  ],
  infoData3: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "3. 게임 방법",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "agentM",
      chat_tit: "에이전트 M",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">추천 라운드 구성</span><br/>사전정보 배분 → 조사1 → 토론 → 조사2 → 토론 또는 추가 조사 → 최종 토론/최종 선택',
    },

    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<p class="txtW700">조사 라운드</p><p class="indentNum">1. 조사할 공간을 정하고, 키워드를 찾아 입력해 사건 정보를 얻습니다.</p><p class="indentNum">2. 획득한 키워드와 단서 내용은 직접 보여줄 수 없으며, 구두로 일부 정보만 교환할 수 있습니다.</p><p class="indentNum">3. 참가자는 <span class="txtW700">진실을 말하거나, 거짓을 말하거나, 착각한 정보를 말할 수도 있습니다.</span></p><p class="indentNum">4. <span class="txtW700">🔒 잠긴 키워드:</span> 비밀번호를 찾아 입력해야 내용을 볼 수 있습니다.</p>※ 일부 단서는 익명(A, B 등)으로 표기됩니다.',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<p class="txtW700">토론 라운드</p><p class="indentNum">1. 돌아가며 자신이 얻은 핵심 정보를 브리핑합니다.</p><p class="indentNum">2. 다른 참가자는 질문 1개만 할 수 있습니다.</p> <p class="indentNum">3. 토론은 여러 번 하는 것을 추천합니다.</p>',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<p class="txtW700">최종 선택</p><p class="indentNum">1. 각자 최종추리를 답변합니다.</p><p class="indentNum"> 2. 에이전트 M의 육하원칙 기반 사건 질문에 답합니다.</p><p class="indentNum">3. 승리 조건: 가장 많은 정답을 맞힌 <span class="txtW700">개인 탐정</span>과 평균 점수가 가장 높은 <span class="txtW700">팀</span>이 함께 선정됩니다.</p>',
    },

    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "게임 시작 하기",
      isLast: true,
      action: "route",
      route: "/info", // action === "route" 일 때
      state: {
        DateVal: "infoData4",
        titImgClass: "messageTit01",
      },
    },
  ],
  infoData4: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "4. 게임 시작",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "agentM",
      chat_tit: "에이전트 M",
      talkType: "chat_b_left_Talk",
      text: '이제 진행자의 진행에 따라 <span class="txtW700">공간 탐색을 의논하고 키워드를 찾아 이동하세요.</span>',
    },

    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "첫번 째 조사를 시작하세요.",
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "조사 시작",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  DATA3: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "에이전트 M에게<br/>알맞은 키워드를 검색하세요.",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "agentM",
      chat_tit: "에이전트 M",
      talkType: "chat_b_left_Talk",
      text: "나는 미스터리 사건을 수사하는 에이전트M.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '네가 찾은 <span class="txtW700">추리 키워드</span>를 알려주면 나의 능력으로',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">키워드</span>에 해당하는<br/>사람/장소/단서가 있는 곳으로 <span class="txtW700">이동</span>이 가능하다.',
    },
    {
      type: "left_txt",
      talkType: "chat_b_left_Talk",
      text: "제한시간 내에 사건을 해결해야한다. 그럼 추리 키워드를 입력해보자.",
    },
    {
      type: "scroll",
    },
  ],
  //bjh32
  quiz01: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV1-A01",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">박진호 (남, 32세) – 데이터 분석</span>',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">공식 정보</span>: 5년 경력, 실수 제로 기록 이서연과 승진 경쟁 중',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">사건 당일</span>: 3월 14일 저녁 5시 35분 작업 시작 평소보다<span class="txtW700"> 1시간 30분 일찍</span> "본사가 급하게 요청해서요"',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">의문</span>: 누가 본사 요청이라고 했나? 확인 전화는 안 했나?',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">추가 정보</span>: 최근 3개월 야간 작업 빈번<p class="dotTxt">2월 15일 밤 11시</p><p class="dotTxt">2월 23일 새벽 2시</p><p class="dotTxt">3월 8일 밤 10시</p>"프로젝트가 바빠서요"',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route", // next | finish | route
      route: "/keywordInput", // action === "route" 일 때
    },
  ],
  //lsy27
  quiz02: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV1-A02",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">이서연 (여, 29세) – 기획</span>',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">공식 정보: </span>전략 기획, 박진호와 승진 경쟁 심리적 안전감 프로젝트 참여',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">의혹 B: 공금 유용</span><br/>2월 18일, 법인카드로 <span class="txtW700">500만원</span> 결제 항목: "전략 컨설팅"',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">문제: </span></br><p class="dotTxt">컨설팅 계약서 없음</p><p class="dotTxt">업체 "○○컨설팅" 연락 불가</p><p class="dotTxt">환급 기록 없음</p>',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">이서연 해명: </span>"그건... 제가 잠시 실수로... 곧 설명드릴게요." 말을 얼버무림.',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">추가 정보: </span>3월 15일 오전 9시, 보고서 출력 후 표정 굳어짐. 하지만 <span class="txtW700">10시 15분</span> 까지 아무 말 없음.',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `<span class="txtW700">최근 상황: </span>[동료 증언] "3월 초부터 이서연이 '이번 승진은 꼭 해야 한다'며 압박감을 드러냈다."`,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //cms27
  quiz03: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV1-A03",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">최민수 (남, 27세) – 운영/시스템</span>',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">공식 정보: </span>조용하고 성실, 시스템 권한 최고 정규직 전환 대기 (통과 확실)',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">과거 사건: 2024년 9월 15일, </span>박진호에게 공개 무시당함<br/>회의실에서 박진호: "시스템 오류 아니고 네가 이해 못 하는 거야"<br/>→ 모두가 웃음<br/>→ 며칠 후 최민수가 옳았던 것으로 판명<br/>→ 박진호 사과, 표면적 화해',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">현재 관계: </span>함께 점심, 커피도 함께 하지만 최민수는 그날 이후로 회의에서 거의 말을 하지 않게 됨',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">담당 업무: </span>3월 14일, 색상 규칙 변경 작업<p class="dotTxt">오후 6시 변경 예정</p><p class="dotTxt">공지문 부착 책임</p>',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">의문: </span>3월 14일 오후 5시~7시 휴대폰 위치 기록 없음 "배터리 나갔어요"',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //khl31
  quiz04: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV1-A04",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">김하린 (여, 31세) – PR</span>',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">공식 정보: </span>언론 대응, PR 우수 사례 선정',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">의혹 A: 기밀 유출</span><p class="dotTxt">3월 10일, 외부 기자와 2시간 미팅</p><p class="dotTxt">3월 11일, 같은 기자 통화 27분</p><p class="dotTxt">3월 12일, 경쟁사에서 유사 전략 발표</p>',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">보안팀 의혹: </span>"회사 신제품 전략이 누출된 것 아닌가?"',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">김하린 해명: </span>"신제품 홍보 사전 작업이었어요. 기밀 유출 절대 아닙니다."<br/><span class="txtW700">하지만, </span>그 기자가 경쟁사 고문과 친분 확인됨',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">추가 정보: </span>3월 13일, 통화 중 목격됨 "...마케팅팀에서 곧..." "...주목할 만한..."',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">3월 14일 저녁: </span>김하린이 사무실에 늦게까지 남아 무언가 고민하는 모습이 목격됨 "말해야 하나... 말아야 하나..."',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //jws38
  quiz05: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV1-A05",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">정우석 (남, 38세) – 팀장</span>',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">공식 정보: </span>민주적 리더십, 부장 승진 후보 프로젝트 리더',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">의혹: 본사 압박</span><br/>3월 15일 오전 10시 25분 본사와 통화 후 표정 굳어짐',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">회의(10시 30분)에서: </span><br/>최민수: "팀장님, 색상 규칙이..."<br/>정우석: "민수씨, 지금은 시간 없어"<br/><span class="txtW700">평소와 다름: </span>항상 끝까지 듣는 스타일인데 이날은 말을 끊음',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">익명 제보: </span>"2월 말, 본사 인사팀장과 고급 레스토랑에서 식사. 테이블에 두꺼운 봉투."',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">익명 제보에 대한 정우석 해명: </span>"업무 미팅이었고 회의 자료였어요"',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">과거 사례: </span>2년 전, 다른 팀에서 팀장으로 있을 때 팀원 한 명이 실수를 했고 그 팀원만 징계를 받았다.<br/>정우석은 보고서를 검토하지 않았음에도 책임을 지지 않았다는 소문이 있음.',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //map12
  quiz06: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV1-A06",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: "사무실 공간 배치도<br/>[5층 마케팅팀]",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "북쪽: [팀장실-정우석] [회의실]",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "중앙: [분석실-박진호] [기획실-이서연] [운영실-최민수] [PR실-김하린]",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "동쪽: [서버룸] 최민수만 출입 [창고] 잠금, 열쇠는 총무팀",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "남쪽: [화장실] [비상계단] 흡연실] 5층 끝, CCTV 사각",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "서쪽: [엘리베이터] [복도 공지판]",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">중요 정보: </span><p class="dotTxt">서버룸: 카드키 출입, 로그 자동 기록</p><p class="dotTxt">비상계단: CCTV 없음</p><p class="dotTxt">흡연실: 법적으로 카메라 설치 불가</p><p class="dotTxt">창고: 3월부터 거의 사용 안 함</p>',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">거리 정보: </span><p class="dotTxt">서버룸 → 흡연실: 도보 2분</p><p class="dotTxt">서버룸 → 1층: 엘리베이터 1분</p><p class="dotTxt">흡연실 → 비상계단: 30초</p>',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //nta24
  quiz07: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV1-B01",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: "나는 박진호, 마케팅 데이터를 분석하는 일을 맡고 있다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "팀에서 가장 빠르게 숫자를 다루고, 복잡한 그래프를 읽어낸다. 사람들은 내가 만든 보고서를 의심 없이 받아들이곤 한다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "내 책상에는 늘 커피잔이 놓여 있고, 분석실 모니터에는 차트와 엑셀 창이 켜져 있다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "나는 데이터가 말하는 사실을 신뢰한다. 그건 내가 가진 유일한 무기이자, 이 회사에서 버틸 수 있는 힘이다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "다른 이들은 감각이나 직관을 말하지만, 나는 수치와 그래프만을 근거로 삼는다. 이것이 내가 존재하는 방식이다.",
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //sdw25
  quiz08: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV1-B02",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: "나는 이서연, 프로젝트 기획을 맡고 있다. 보고서의 흐름을 만들고, 전략을 짜는 게 내 역할이다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "동료들이 보는 내 모습은 차분하고 꼼꼼한 기획자다. 항상 정돈된 복장으로 회의실에 앉아, 자료를 검토하고 펜으로 노트를 채운다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "나는 직관적으로 이상 신호를 잘 포착한다. 남들이 지나치는 작은 차이를 발견할 때가 많다. 그러나 겉으로는 잘 드러내지 않는 편이다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "내 표정은 조용하지만, 눈은 늘 계산 중이다. 나는 늘 질문을 삼키며, 기회를 기다린다.",
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //mpt23
  quiz09: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV1-B03",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: "내 이름은 최민수, 시스템 운영을 담당한다. 대시보드 업데이트, 서버 로그, 공지판 관리가 내 몫이다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "늘 캐주얼한 복장에 이어폰을 꽂고 일한다. 말이 많지 않고, 존재감도 크지 않다. 사람들은 나를 조용히 묵묵히 일하는 사람이라 부른다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "내 책상엔 노트북과 포스트잇이 늘 붙어 있다. 나는 겉으로 티를 내지 않지만, 시스템 내부에서 무슨 일이 벌어지는지는 누구보다 잘 안다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "내가 모르는 일은 거의 없다. 하지만, 내가 아는 걸 꼭 말할 필요는 없을지도 모른다.",
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //kpw26
  quiz10: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV1-B04",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: "나는 김하린, PR 담당이다. 외부 발표와 언론 대응은 내 손에 달려 있다. 깔끔한 블라우스를 입고, 항상 전화기를 옆에 두고 대기한다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "회의에서 내 발언은 명확하고 정제돼 있다. 팀원들은 내가 말을 포장한다고 생각한다. 그러나 위기 상황에서 필요한 건 솔직함이 아니라 메시지다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "나는 이미지와 단어를 다루는 전문가다. 내가 정리한 문장은 밖으로 흘러나가 회사를 지탱하는 방패가 된다. 나는 그 방패를 쥔 사람이다.",
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //bdy20
  quiz11: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV1-B05",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: "나는 정우석, 이 팀의 리더다. 보고와 성과는 내 책임이다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "나는 수트를 입고 매일 팀장실에 앉아, 본사와 통화를 하고 서류에 도장을 찍는다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "동료들은 나를 권위적이라고 부른다. 하지만 내가 없으면 이 팀은 흩어진다. 나는 결정하는 사람이다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "누군가 주저할 때, 나는 길을 낸다. 시간이 부족해도, 답을 내는 건 내 몫이다. 나는 팀을 지켜야 한다.",
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //mog29
  quiz12: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV1-B06",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: "개발팀 단서 – 화이트보드 흔적",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "회의실 한쪽 화이트보드에 지워진 흔적이 희미하게 남아 있다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "옅은 선을 따라가면 '리스크'라는 단어가 적혀 있었음을 알 수 있다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "하지만 그 위에 덮어 쓴 메모는 '안정적 진행'이었다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "흰 천으로 급히 지운 자국이 그대로 남아 있다. 회의에 있던 누구도 그 순간을 말하지 않았다.",
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //cle01
  quiz13: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV2-1",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">청소부 이순자 증언: </span>"매일 저녁 9시 청소합니다."',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">3월 14일 9시 정각: </span>불 켜진 곳<p class="dotTxt">분석실 (박진호)</p><p class="dotTxt">기획실 (이서연)</p><p class="dotTxt">서버룸 (불빛 새어나옴)</p>',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">9시 25분경: </span>복도에서 <span class="txtW700">하이힐 소리</span> 여자 같았어요 방향: 기획실 → 비상계단 쪽',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">9시 35분경: </span>분석실만 불 켜짐',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">10시 5분: </span>박진호씨 책상에 엎드려 자는 것처럼 계셔서 피곤한가보다 하고 안 깨웠어요.',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">11시 30분 (퇴근 시): </span>분석실 불 꺼짐',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //gar02
  quiz14: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV2-2",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">경비원 박철수 증언: </span>출입 로그 확인했습니다.<p class="dotTxt">3월 14일 서버룸</p><p class="dotTxt">입실: 17:45</p><p class="dotTxt">퇴실: 18:20</p>→ 총 35분 체류',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '최민수가 1층 로비 도착: <span class="txtW700">18:47</span>',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "경비원이 엿들은 소리: 누군가 오후 5시 47분을 강조해서 이야기",
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //del03
  quiz15: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV2-3",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">배달원 김민준 증언: </span>치킨 배달 갔어요.<p class="dotTxt">3월 14일 저녁 7시 10분</p><p class="dotTxt">5층 마케팅팀<br/>주문자: 박진호</p>',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "복도에서 박진호 씨를 만났는데 눈이 풀려있고 비틀거리는 듯해서",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "'괜찮으세요?'라고 했더니, <br/>'아... 네... 감사합니다...' (멍한 반응) 이라고 했어요.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">그리고 복도 끝 흡연실</span> 근처에서 누군가 나오는 걸 봤어요.',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "검은 후드티를 입은 사람, 키는 170cm 정도, 남자인지 여자인지 모르겠어요. 얼굴 못 봤어요.",
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //sto04
  quiz16: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV2-4",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk2",
      text: "창고 열쇠 관리 기록",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">3월 14일: 오후 6시 12분경</span><br/>누군가 열쇠 빌려감',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '대여 기록:<p class="dotTxt">서명: 흘려 써서 판독 어려움</p><p class="dotTxt">반납: 6시 38분</p>',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">다음날(3월 15일) 창고 점검: </span><p class="dotTxt">구석에 검은 후드티 발견</p><p class="dotTxt">주인 찾는 사람 없음</p><p class="dotTxt">현재 분실물 보관함에 있음</p>',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '<span class="txtW700">※ 비밀번호 힌트: 열쇠 반납 시각 (군용시간 4자리)</span>',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //hrd05
  quiz17: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV2-5",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk2",
      text: "인사팀 내부 문서<br/>본사 인사팀 내부 자료 (유출)",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: "[2025년 상반기 승진 심사]",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "[마케팅팀]<br/>과장 후보:<br/>- 박진호 (평가 A+, 실적 우수)<br/>- 이서연 (평가 A+, 실적 우수)<br/>부장 후보:<br/>- 정우석 (평가 A, 실적 양호)",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '방침:<br/>"과장 2명 모두 승진 가능"<br/>"단, 중대 과실 발생 시 제외"<br/>"부장 승진은 팀 성과와 연동"',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '핵심: 박진호와 이서연, <span class="txtW700">둘 다 승진 가능. 팀원들은 본사 방침을 모르는 상황.</span>',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //loc06
  quiz18: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV2-6",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk2",
      text: "정답!<br/>1838",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: "🔓 창고 출입 상세 기록",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `<span class="txtW700">CCTV 저화질 영상 복원:</span>
        <p class="dotTxt">18:12:34<br/>문 열림 검은 후드티 입은 인물 키 약 170cm 얼굴 확인 불가</p>
        <p class="dotTxt">18:15:22<br/>- 창고 구석으로 이동 무언가를 숨기는 동작<br/>- 후드티를 벗어 구석에 둠</p>
        <p class="dotTxt">18:18:05<br/>- 창고 내에서 휴대폰 확인<br/>- 휴대폰 화면 빛 확인됨<br/>- 문자를 보내는 듯한 동작</p>
        <p class="dotTxt">18:36:48<br/>- 퇴실<br/>- 평상복 (검은 티셔츠, 청바지)<br/>- 후드티 없이 나감</p>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `AI 분석결과
        <p class="dotTxt">후드티 주인공 성별이 남성 확률 (70%)</p>
        <p class="dotTxt">후드티 주인 = 창고 방문자</p>
        <p class="dotTxt">휴대폰 사용 흔적 확인</p>
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  quiz18_q: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV2-6",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk2",
      text: "🔒 창고 출입 기록 상세본",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "힌트: 열쇠 반납 시각 (군용시간 4자리)",
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //smk01
  quiz19: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV3-1",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk2",
      text: "흡연실 포렌식",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: '<p class="dotTxt">5층 흡연실 (CCTV 사각지대)</p><p class="dotTxt">발견 증거 2개</p>',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '1. 휴지통에 찢어진 종이<p class="dotTxt">메모 조각 복원:</p><p class="dotTxt">계획 최종 체크<br/>17:47 시작<br/>18:00 로그<br/>18:22 삭제<br/>(일부 글자 훼손됨)</p>',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '2. 벽면에 붙은 포스트잇 (구겨진 채)<p class="dotTxt">메모 내용: "09 _ _ 잊지 말 것" (뒤 두 자리 훼손됨)</p>',
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //sr02
  quiz20: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV3-2",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk2",
      text: "서버룸 내부 CCTV (저화질)",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `<span class="txtW700">3월 14일 영상:</span>
      <p class="dotTxt">
        <span class="txtW700">17:45-18:00 (15분):</span><br/>
        <span class="txtW700">- 화면이 흐릿함</span><br/>
        - 렌즈에 뭔가 가린 듯<br/>
        - 누군가 입실<br/>
        - 컴퓨터 작업 확인됨
      </p>
      <p class="dotTxt">
        <span class="txtW700">18:00-18:05 (5분):</span><br/>
        - 누군가의 실루엣만 보임<br/>
        - 무엇을 하는지 불명확
      </p>
      <p class="dotTxt">
        <span class="txtW700">18:05-18:20 (15분):</span><br/>
        - 마무리 작업<br/>
        - 18:20 퇴실<br/>
        - 화면 다시 선명
      </p>`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `<span class="txtW700">전산팀 분석:</span><br/>
        17:45-18:20 사이<br/>
        카메라 렌즈를 포스트잇으로 가린 것으로 추정.<br/>
        로그 조작 화면이 CCTV에 찍히지 않게 하려는 의도로 보임.`,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //fc03
  quiz21: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV3-3",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk2",
      text: "B의 컴퓨터 포렌식 분석",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `<p class="dotTxt">17:35:00<br/>- 컴퓨터 부팅</p>
        <p class="dotTxt">17:36:22<br/>- 대시보드 프로그램 실행</p>
        <p class="dotTxt">17:48:15<br/>- 화면 캡처</p>
        <p class="dotTxt">17:55:00<br/>- 엑셀 작성 시작</p>
        <p class="dotTxt">18:10:00<br/>- 중간 저장<br/>...</p>
        <p class="dotTxt">23:05:00<br/>- 최종 저장</p>`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `17:48 캡처 이미지 
        <p class="dotTxt">빨간색 그래프</p>
        <p class="dotTxt">상승 방향 화살표</p>`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `B의 증언
        <p class="dotTxt">빨간색을 보고 하락이라고 생각했어요.</p>
        <p class="dotTxt">평생 그렇게 봐왔으니까요.</p>
        <p class="dotTxt">화살표는... 잘 안 보였어요.</p>`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `휴대폰 복구 데이터
        <p class="dotTxt">삭제된 문자 발견</p>
        <p class="dotTxt">수신: 17:20<br/>
          발신자: (번호 표시 안 됨)<br/>
          내용: 데이터 급히 확인 필요. 본사 요청. 6시 전에 초안이라도.
        </p>`,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //sta04
  quiz22: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV3-4",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk2",
      text: "비상계단 조사",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `<p class="dotTxt">5층 비상계단 (CCTV 없음)</p>
        <p class="dotTxt">발견 증거 있음</p>`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `1. 난간 지문
        <p class="dotTxt">여러 사람 지문</p>
        <p class="dotTxt">선명한 지문 4개:<br/>
          <span class="dotTxt">이서연</span><br/>
          <span class="dotTxt">최민수</span><br/>
          <span class="dotTxt">정우석</span><br/>
          <span class="dotTxt">박진호</span>
        </p>`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `3층 계단 담배꽁초
        <p class="dotTxt">날짜: 3월 14일 추정</p>`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `4층 계단에 작은 메모
        <p class="dotTxt">18:05 완료</p>
        <p class="dotTxt">연필로 급히 쓴 듯</p>`,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //dra05
  quiz23: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV3-5",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk2",
      text: "C의 책상 조사",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `<p class="dotTxt">C의 책상 서랍 (영장으로 수색)</p>
        <p class="dotTxt">발견: 서랍 뒤쪽에 봉투</p>
        <p class="dotTxt">내용: 현금 500만원</p>
        <p class="dotTxt">메모: "3월 말 환급 - M”</p>`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `<span class="txtW700">C의 진술:</span><br/>
        “동료 한 명이 2월에 급히 돈이 필요하다고... 가족 병원비래서... 동료 한 명은 법인카드 권한이 없어서,`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `제 법인카드로 가짜 컨설팅 결제를 하고, 그 업체(동료 한 명의 지인)가 현금으로 동료 한 명에게... 3월 말에 동료 한 명이 환급하기로 했어요.`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `이 500만원이 그 돈이에요. 불법인 줄 알았지만... 동료 한 명이 간절해서... 저도... 잘못했어요."`,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //caf06
  quiz24: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV3-6",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `<span class="txtW700">사내 카페 직원 증언: </span>3월 14일 오후 기억나요.`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `<span class="txtW700">오후 5시 15분경: </span>아메리카노 2잔 주문한 분이 있었어요.`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `<span class="txtW700">검은 후드티 </span>입은 남자분. 조용하고 말이 별로 없었어요.<br/>
        '누구랑 드시려고요?' 물었더니 '혼자요. 하나는 나중에.'`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `<span class="txtW700">이상한 점: </span>커피 받고 나서 한 잔은 바로 마시고, 다른 한 잔은
        소매에 일부러 쏟은 것 같았어요.<br/>
        '아, 죄송해요' 하면서 휴지로 대충 닦고 나갔어요.<br/>
        왜 그랬는지는 모르겠지만...얼굴은 잘 기억 안 나는데,<br/>
        포스트잇을 손에 들고 있었어요.<br/>
        뭔가 숫자가 적혀 있던 것 같은데...`,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //sbt07
  quiz25: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV3-7",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk2",
      text: `정답!<br/>1747`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `🔓 서버 내부 메모리 덤프 분석`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `[실제 시스템 변경 기록]
        <p class="dotTxt">17:46:18<br/>- config.xml 수정됨</p>
        <p class="dotTxt">17:46:45<br/>- 색상 규칙 변경 실행</p>
        <p class="dotTxt">17:47:12<br/>- 시스템 재시작</p>
        <p class="dotTxt">17:47:33<br/>- 변경 완료, 즉시 반영</p>`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `[표시용 로그 - 조작됨]
        <p class="dotTxt">18:00:00<br/>- 색상 규칙 변경 실행</p>
        <p class="dotTxt">18:03:24<br/>- 변경 완료</p>`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `<span class="txtW700">결론:</span>
        <p class="dotTxt">실제 변경 시각: 17:47</p>
        <p class="dotTxt">로그 표시 시각: 18:00</p>
        <p class="dotTxt">차이: 8분 조작</p>`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `<span class="txtW700">조작 권한: </span>서버룸 출입자만 가능`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `<span class="txtW700">의미: </span>누군가 시스템을 일찍 변경하고 로그를 나중 시각으로 조작했다.`,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  quiz25_q: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV3-7",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `🔒 전산팀 서버 로그 - 상세 분석본`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `힌트
        <p class="dotTxt">경비원이 들은 무엇</p>
        <p class="dotTxt">흡연실 메모의 " &nbsp;: 시작"</p>
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //pho01
  quiz26: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV4-1",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk2",
      text: `A의 휴대폰 기초 분석`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `모델명 : ps-1057`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `A의 휴대폰 포렌식<br/>
        <span class="txtW700">위치 기록:</span>
        <p class="dotTxt">17:00-17:44 - 5층 운영실 </p>
        <p class="dotTxt">17:45-18:20 - 5층 서버룸 </p>
        <p class="dotTxt">18:20-18:45 - 기록 없음 (꺼짐)</p>
        <p class="dotTxt">18:45-19:00 - 1층 로비</p>`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `인터넷 전화 앱 발견:<br/>
        [예약 발송 설정 흔적]<br/>
        <p class="dotTxt">설정 일시: 3월 14일 17:00</p>
        <p class="dotTxt">발송 예약: 17:20 (자동)</p>
        <p class="dotTxt">수신자: 박진호</p>`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `삭제된 로그 일부 복구:
        <p class="dotTxt">18:22 - 앱 접속</p>
        <p class="dotTxt">18:22 - 발송 내역 삭제 시도</p>
        <p class="dotTxt">18:23 - 계정 설정 초기화</p>`,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //evi02
  quiz27: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV4-2",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk2",
      text: `B의 컴퓨터 심화 분석`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `B의 17:48 캡처 이미지<br/>
        <span class="txtW700">메타데이터 정밀 분석:</span>`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `[이미지 파일 정보]
        <p class="dotTxt">생성 시각: 17:48:15</p>
        <p class="dotTxt">색상 프로파일: <br/>RGB(255,0,0) - 빨강</p>`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `[시스템 정보]<br/>프로그램 버전: Dashboard v2.1 색상 규칙: RED=상승, BLUE=하락`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `[마지막 시스템 업데이트]<br/>업데이트 일시: 17:47:33`,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //wit03
  quiz28: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV4-3",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk2",
      text: `C의 최종 진술`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `<span class="txtW700">사건 D (의도적 방치) 진실:</span>`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `3월 15일 오전 9시 20분, 보고서를 출력했을 때 명백한 오류를 발견했어요. 그래프는 상승인데 제목은 하락. 하지만... 확신할 수 없었어요.`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `1년 전, 제가 회의에서 문제를 지적했다가 제 착각이었던 적이 있어요. 그때 정말 창피했어요. '확인도 안 하고 함부로 말하네'`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `그래서 이번에는 팀장님께 먼저 조심스럽게 물어봤어요. 10시 15분에 팀장실로 갔어요. '팀장님, 보고서가 이상한 것 같은데... 제가 확인해봐도 될까요?'`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `팀장님은 말했어요.<br/>'확실한 증거가 있어? 확인해보고 다시 얘기해줘. 지금은 시간이 급해서.'`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `저는... 그 말을 듣고<br/>'확인하지 말라'는 뜻으로 들렸어요. 착각이었나요? 그래서 침묵했어요. 틀릴까봐 무서웠어요.`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `그런데... 솔직히 말하면, 박진호가 실수하면 제가 유리해지잖아요. 그 생각이 스쳤어요. 잠깐이요. 저도 제 마음을 모르겠어요.`,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //fin04
  quiz29: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV4-4",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk2",
      text: `A의 자백`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `모두 인정합니다…`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `그날, 내가 한 일이 있어요. 하지만 글쎄요. 그게 과연 저만의 책임일까요?`,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //lck05
  quiz30: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV4-5",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk2",
      text: `정답!<br/>0915`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `🔓 A의 개인 일기장`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `2024년 9월 15일<br/>
        "오늘 회의에서 진호 선배가 '네가 이해 못 하는 거야'<br/>
        모두가 웃었다. 나는 죽고 싶었다. 이 날(0915)을 평생 잊지 못할 것이다."`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `2024년 10월<br/>
        "박진호가 사과했다. 하지만 내 마음의 상처는? 사람들은 여전히 나를 그때 그 사람으로 본다. '아, A? 그래, 그때 틀렸던...'"`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `2025년 1월<br/>
        "언젠가 박진호도 실수하겠지. 그때가 오면..."`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `2025년 2월<br/>
        "IT 보안 교육에서 로그 조작 방법을 배웠다. 강사는 '절대 악용하지 마세요'라고 했지만, 내 머릿속엔 이미 계획이 그려졌다."`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `2025년 3월 10일<br/>
        "본사에서 색상 규칙 변경 지시.<br/>
        만약... 박진호가 일찍 작업하면? 색상이 바뀌는 중간에? 혼란스러울 것이다.<br/>
        나는 아무것도 하지 않는다. 단지 타이밍을 조절할 뿐이다."`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `2025년 3월 12일<br/>
        계획 완성.<br/>
        <p class="dotTxt">17:00 - 예약 문자 설정 </p>
        <p class="dotTxt">17:20 - 자동 발송 (진호를 일찍) </p>
        <p class="dotTxt">17:47 - 실제 변경 실행 </p>
        <p class="dotTxt">18:00 - 로그 18:00으로 조작 </p>
        <p class="dotTxt">18:05 - CCTV 복원 </p>
        <p class="dotTxt">18:18 - 완벽한 공지 </p>
        <p class="dotTxt">18:22 - 흔적 삭제</p>
        아무도 나를 의심 못 한다. 나는 가장 완벽하게 공지할 것이다."`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `2025년 3월 14일<br/>
        "오늘이다. 진호 선배, 미안하지만... 당신도 한 번은 느껴야 합니다. 0915 그날의 기분을.<br/>
        그 순간 얼마나 작아지는지, 얼마나 투명해지는지, 얼마나 외로운지...<br/>
        당신도 알아야 합니다."`,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  quiz30_q: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV4-5",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk2",
      text: "A의 일기",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `힌트
        <p class="dotTxt">숫자 4개</p>
        <p class="dotTxt">A가 절대 잊지 못하는 날</p>
        <p class="dotTxt">흡연실 포스트잇</p>
        <p class="dotTxt">과거 사건</p>
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //clu06
  quiz31: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV4-6",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk2",
      text: `정답!<br/>1057`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `🔓 A의 휴대폰 삭제된 메모 앱 전체 복구`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `✓ 17:00 - 예약 문자 설정 완료 <br/>
        ✓ 17:20 - 자동 발송 (진호를 일찍 시작하게)<br/>
        ✓ 17:45 - 서버룸 입실<br/>
        ✓ 17:47 - 실제 시스템 변경 실행<br/>
        ✓ 18:00 - 로그를 18:00으로 조작<br/>
        ✓ 18:00-18:05 - CCTV 렌즈 가림 (포스트잇)<br/>
        ✓ 18:05 - 렌즈 복원<br/>
        ✓ 18:18 - 공지문 중앙에 크게 부착<br/>
        ✓ 18:20 - 서버룸 퇴실<br/>
        ✓ 18:22 - 흡연실 이동, 위치 기록 끄기<br/>
        ✓ 18:25 - 휴대폰 부품 제거, 앱 데이터 삭제<br/>
        ✓ 18:30 - 후드티 창고에 숨김 <br/>
        ✓ 18:45 - 1층 도착<br/>
        완벽.`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `삭제된 사진 앨범 복구:
        <p class="dotTxt">서버룸 config.xml 파일 스크린샷 (17:47)</p>
        <p class="dotTxt">로그 조작 전후 비교 사진</p>
        <p class="dotTxt">공지문 출력 전 시안 사진 (18:12)</p>
        <p class="dotTxt">흡연실에서 휴대폰 부품 제거 중 사진 (18:25)</p>`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `예약 문자 원본:
        <p class="dotTxt">발신 예약: 3월 14일 17:20 </p>
        <p class="dotTxt">수신자: 박진호</p>
        <p class="dotTxt">내용: "진호님, 데이터 급히 확인 필요. 본사 요청. 6시 전에 초안이라도."</p>`,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  quiz31_q: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV4-6",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk2",
      text: "A의 휴대폰",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "힌트: A의 휴대폰 모델명 숫자 4자리",
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //khr07
  quiz32: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV4-7",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk2",
      text: `D의 최종 조사 결과`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `<span class="txtW700">의혹 A (기밀 유출) 결론:</span><br/>
        보안팀 심화 조사:<br/>
        "3월 10-11일 D와 기자의 대화 내용 외부 CCTV 음성 복원 완료.
        <p class="dotTxt">주제: 신제품 홍보 전략 내용: 정상적인 PR 협의</p>
        <p class="dotTxt">3월 12일 경쟁사 발표는 우연의 일치 가능성 높음.</p>
        <p class="dotTxt">단, 3월 11일 통화 중 5분간<br/>*음성 복원 실패 구간 존재.</p>`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `<span class="txtW700">D의 고백:</span><br/>
        3월 14일 저녁, 보고서 초안을 봤어요. 뭔가 이상했지만 확신할 수 없었어요.<br/>
        말하면 혼란이 커질까봐... 회사 이미지가 무너질까봐...<br/>
        <span class="txtW700">그래서 침묵했어요.</span><br/>
        PR 담당으로서 진실보다 평판을 선택했어요.<br/>
        지금 생각하면, 그게 제 가장 큰 실수였어요.`,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //jws08
  quiz33: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "INV4-8",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `2월 28일 레스토랑 CCTV 복원:<br/>
        테이블 위 봉투 내용:<br/>
        <p class="dotTxt">승진 심사 자료</p>
        <p class="dotTxt">팀 성과 보고서</p>`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `<span class="txtW700">3월 15일 본사 통화 녹음:</span>
        <p class="dotTxt">본사: 팀장님, 오후 3시까지입니다.</p>
        <p class="dotTxt">정우석: 네, 알고 있습니다.</p>
        <p class="dotTxt">본사: 지연되면 팀 전체 재평가 들어갑니다.</p>
        <p class="dotTxt">정우석: ...알겠습니다.</p>
        <p class="dotTxt">본사: 부장 승진도 영향받을 수 있어요.</p>`,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `<span class="txtW700">3월 14일 오후 5시 30분 회의 녹음:</span>
        <p class="dotTxt">C: 팀장님, 색상 규칙 변경이...</p>
        <p class="dotTxt">정우석: C씨, 지금은 긴급 보고 건이 있어서. 나중에 얘기합시다.</p>
        <p class="dotTxt">C: 하지만 이건 중요한...</p>
        <p class="dotTxt">정우석: 알았어요. 나중에. 회의 끝.</p>`,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "확인 완료",
      isLast: true,
      action: "route",
      route: "/keywordInput",
    },
  ],
  //end11
  end_q1: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "수집한 단서를 바탕으로 답하세요.<br/>총 100점 만점",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `Q1. 보고서 오류 사건의 진짜 범인은 누구인가?
        <p class="indentTxt">1. 박진호 - 데이터를 고의로 잘못 작성</p>
        <p class="indentTxt">2. 이서연 - 문제를 알고도 침묵</p>
        <p class="indentTxt">3. 최민수 - 시스템을 조작해 박진호를 함정에 빠뜨림</p>
        <p class="indentTxt">4. 김하린 - 사건을 예상하고 이용</p>
        <p class="indentTxt">5. 정우석 - 팀원 발언을 막아 방치</p>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: "정답을 숫자로 입력하세요.",
    },
  ],
  end_q2: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "수집한 단서를 바탕으로 답하세요.<br/>총 100점 만점",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `Q2. 범행의 핵심 시간은 언제였나?
        <p class="indentTxt">1. 17:20 (박진호가 문자 받은 시각)</p>
        <p class="indentTxt">2. 17:47 (실제 시스템 변경 시각)</p>
        <p class="indentTxt">3. 18:00 (공식 로그 시각)</p>
        <p class="indentTxt">4. 18:18 (공지문 부착 시각)</p>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: "정답을 숫자로 입력하세요.",
    },
  ],
  end_q3: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "수집한 단서를 바탕으로 답하세요.<br/>총 100점 만점",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `Q3. 최민수의 범행에서 가장 핵심적인 조작은?
        <p class="indentTxt">1. 서버 로그의 시간을 18:00으로 조작</p>
        <p class="indentTxt">2. 가짜 문자로 박진호를 일찍 시작하게 유도</p>
        <p class="indentTxt">3. CCTV 렌즈를 가려 증거 은폐</p>
        <p class="indentTxt">4. 공지문을 일부러 늦게 부착</p>
        <p class="indentTxt">5. 박진호의 컴퓨터를 원격 조작</p>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: "정답을 숫자로 입력하세요.",
    },
  ],
  end_q4: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "수집한 단서를 바탕으로 답하세요.<br/>총 100점 만점",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `Q4. 최민수가 만든 "완벽한 알리바이"는 무엇인가?
        <p class="indentTxt">1. 서버룸에 들어가지 않은 것처럼 위장</p>
        <p class="indentTxt">2. 18:18에 완벽한 공지문을 부착해 "제대로 공지했다"고 증명</p>
        <p class="indentTxt">3. 다른 사람에게 범행을 떠넘김</p>
        <p class="indentTxt">4. 사건 당일 휴가를 내서 현장에 없었음을 증명</p>
        <p class="indentTxt">5. 박진호가 먼저 규칙을 알고 있었다고 주장</p>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: "정답을 숫자로 입력하세요.",
    },
  ],
  end_q5: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "수집한 단서를 바탕으로 답하세요.<br/>총 100점 만점",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `Q5. 최민수는 왜 이런 범죄를 저질렀나?
        <p class="indentTxt">1. 승진을 위해</p>
        <p class="indentTxt">2. 금전적 이득을 위해</p>
        <p class="indentTxt">3. 6개월 전 공개적 모욕에 대한 복수</p>
        <p class="indentTxt">4. 회사 시스템 개선을 위해</p>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: "정답을 숫자로 입력하세요.",
    },
  ],
  end_q6: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "수집한 단서를 바탕으로 답하세요.<br/>총 100점 만점",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `Q6. 이서연은 왜 침묵했나?
        <p class="indentTxt">1. 범인을 보호하기 위해</p>
        <p class="indentTxt">2. 과거 트라우마로 틀릴까봐 두려워서</p>
        <p class="indentTxt">3. 개인적 이득을 위해</p>
        <p class="indentTxt">4. 팀장의 지시에 따라</p>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: "정답을 숫자로 입력하세요.",
    },
  ],
  end_q_finish: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: "모든 추론을 마쳤습니다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "사건의 전말을 확인하고<br/>추론 점수를 확인하세요.",
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "사건의 전말 확인하기",
      isLast: true,
      action: "route",
      route: "/info",
      state: {
        DateVal: "finish",
        titImgClass: "finishTit",
      },
    },
  ],
  finish: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "🌱 씨앗 | 2024년 9월 15일",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '회의 중 박진호가 최민수를 공개적으로 무시했다. "시스템 오류 아니고 네가 이해 못 하는 거야." 모두가 웃었다.',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `며칠 후 최민수가 옳았음이 밝혀졌다. 박진호는 사과했고, 최민수는 "괜찮다"고 했다.<br/>
        <span class="txtW700">박진호는 그 말을 믿었다. 다시 물어보지 않았다.</span><br/>
        하지만 최민수는 괜찮지 않았다. 그날 이후 회의에서 거의 말을 하지 않게 되었다.
      `,
    },
    {
      type: "chatInfo_Talk1",
      marType: "mb20 mt40",
      text: "🔧 계획 | 2025년 2~3월",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: "2월, IT 보안 교육에서 로그 조작 방법을 배웠다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `3월 10일, 본사에서 색상 규칙 변경 지시가 내려왔다.
        <p class="dotTxt">기존: 빨강=하락</p>
        <p class="dotTxt">변경: 빨강=상승</p>
        <p class="dotTxt">변경 시각: 3월 14일 18:00</p>
        <p class="dotTxt">담당자: 최민수</p>
        최민수는 깨달았다. "박진호가 변경 전에 작업하면... 색상을 착각할 것이다."
      `,
    },
    {
      type: "chatInfo_Talk1",
      marType: "mb20 mt40",
      text: "⚡ 실행 | 2025년 3월 14일",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `<p class="dotTxt">17:00  예약 문자 설정 (인터넷 전화 앱)</p>
        <p class="dotTxt">17:15  카페에서 커피 구입, 후드티에 일부러 쏟음 </p>
        <p class="dotTxt">17:20  가짜 문자 자동 발송 → 박진호 조기 작업 유도 </p>
        <p class="dotTxt">17:30  정우석, 최민수 경고 무시 ("나중에 얘기해") </p>
        <p class="dotTxt">17:35  박진호 작업 시작 </p>
        <p class="dotTxt">★17:47 최민수, 실제 시스템 변경 (핵심)</p>
        <p class="dotTxt">17:48 박진호 화면 캡처 (빨간 그래프 → "하락"으로 착각)</p>
        <p class="dotTxt">18:00  로그를 18:00으로 조작</p>
        <p class="dotTxt">18:00-18:05  CCTV 렌즈 가림 (로그 조작 장면 은폐) </p>
        <p class="dotTxt">18:15  창고에 후드티 은닉 </p>
        <p class="dotTxt">18:18  공지문 완벽하게 부착 (알리바이)</p>
        <p class="dotTxt">18:22  흡연실에서 휴대폰 증거 삭제</p>
        <p class="dotTxt">18:47  1층 로비 도착 (자연스러운 퇴근)</p>
        <p class="dotTxt">23:05  박진호, 틀린 보고서 완성 ("-20% 하락")</p>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `<span class="txtW700">핵심 트릭:</span>
        <p class="dotTxt">박진호는 17:48에 캡처했는데, 시스템은 이미 변경되어 있었다</p>
        <p class="dotTxt">하지만 로그는 18:00으로 조작 → "박진호가 일찍 시작해서 착각한 것"처럼 보임</p>
        <p class="dotTxt">공지는 18:18에 완벽하게 부착 → "최민수는 제대로 했다"는 알리바이</p>
      `,
    },
    {
      type: "chatInfo_Talk1",
      marType: "mb20 mt40",
      text: "🤐 침묵들 | 2025년 3월 15일",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `시각인물상황
        <p class="dotTxt">09:00 이서연<br/>오류 발견<br/>→ 1년 전 창피했던 기억<br/>→침묵</p>
        <p class="dotTxt">10:15 이서연<br/>팀장에게 문의<br/>→ "확인하고 다시 와"<br/>→침묵</p>
        <p class="dotTxt">14:00 김하린<br/>이상 발견<br/>→ 회사 이미지 걱정<br/>→ 침묵</p>
        <p class="dotTxt">15:00<br/>-틀린 보고서 본사 제출</p>
        <p class="dotTxt">16:30<br/>-오류 발각, 박진호 정직 처분</p>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `발견된 결정적 증거들:
        <p class="dotTxt">증거비밀번호내용</p>
        <p class="dotTxt">창고 출입 기록</p>
        <p class="dotTxt">1838</p>
        <p class="dotTxt">후드티 은닉 장면</p>
        <p class="dotTxt">서명 "최○○"</p>
        <p class="dotTxt">서버 로그 실제 변경 17:47</p>
        <p class="dotTxt">로그 18:00 조작</p>
        <p class="dotTxt">최민수 일기</p>
        <p class="dotTxt">6개월간의 복수 계획</p>
        <p class="dotTxt">휴대폰 복구</p>
        <p class="dotTxt">휴대폰부품예약 문자</p>
        <p class="dotTxt">범행 체크리스트</p>
      `,
    },
    {
      type: "chatInfo_Talk1",
      marType: "mb20 mt40",
      text: "🗣️ 자백",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: '최민수: "6개월 전 그날, 제가 얼마나 작아졌는지 아무도 몰라요. 사과는 받았지만 상처는 그대로였어요. 진호 선배도 한 번쯤 느껴야 한다고 생각했어요."',
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: '박진호: "민수야, 미안해. 네 상처를 정말로 몰랐어."',
    },
    {
      type: "chatInfo_Talk1",
      marType: "mb20 mt40",
      text: "💬 교훈",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: "범인은 최민수 한 명.<br/>하지만 사건을 만든 건 다섯 가지 침묵.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `인물 침묵
        <p class="dotTxt">최민수: 상처를 말하지 못함</p>
        <p class="dotTxt">박진호: 상처를 확인하지 않음</p>
        <p class="dotTxt">이서연: 두려워서 말하지 못함</p>
        <p class="dotTxt">정우석: 시간에 쫓겨 듣지 못함</p>
        <p class="dotTxt">김하린: 이미지 때문에 말하지 못함',</p>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `CEO:<br/>
        "심리적 안전감은 제도만이 아닙니다.<br/>
        침묵 속 상처를 보는 눈, <br/>
        작아진 사람을 일으켜 세우는 손이 필요합니다."
      `,
    },
    {
      type: "leftCharacter",
      marType: "mb8 mt81",
      chat_icon: "agentM",
      chat_tit: "에이전트 M",
      talkType: "chat_b_left_Talk",
      text: "사건 A01, ‘오피스의 미해결 사건’의 전말이 드러났다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "이것은 한 사람의 실수가 아니었다. 데이터의 착각, 침묵, 압박, 이미지 관리… 작은 균열이 모여 조직 전체를 흔들었다.",
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: "기억해라, 인턴 요원들. 진실은 언제나 말해지지 않은 곳에 숨어 있다. 그 침묵을 뚫어야만 사건은 해결된다. 그리고, 그 침묵을 깨뜨릴 용기가 너희에게 있는가?",
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "방탈출 인증서 확인하기",
      isLast: true,
      action: "route",
      route: "/clear",
    },
  ],
};
